export enum SceneEvent {
  EVENT = 'sceneevent'
}
